import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lightTheme as theme } from '../../theme';

const Wrapper = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    border-radius: 10px;
    background: ${theme.colors.gray200};
`;

const SegmentButton = styled.button`
    border: 0;
    border-radius: 8px;
    padding: 6px 12px;
    min-width: 38px;
    height: 32px;
    background: ${({ $active }) => ($active ? theme.colors.paper : 'transparent')};
    color: ${({ $active }) => ($active ? theme.colors.text : theme.colors.textSecondary)};
    box-shadow: ${({ $active }) => ($active ? theme.colors.shadowSm : 'none')};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 13px;
    font-weight: 600;
`;

function SegmentedControl({ value, onChange, options, ariaLabel }) {
    return (
        <Wrapper role='tablist' aria-label={ariaLabel}>
            {options.map((option) => {
                const isActive = value === option.value;
                return (
                    <SegmentButton
                        key={option.value}
                        type='button'
                        role='tab'
                        aria-selected={isActive}
                        title={option.title || option.label}
                        $active={isActive}
                        onClick={() => onChange(option.value)}
                    >
                        {option.icon || null}
                        {option.label || null}
                    </SegmentButton>
                );
            })}
        </Wrapper>
    );
}

SegmentedControl.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.node,
        })
    ).isRequired,
};

SegmentedControl.defaultProps = {
    ariaLabel: 'Segmented control',
};

export default SegmentedControl;

